/**
 * Overlap Warning Modal Component
 * File: src/components/overlapWarningModal/OverlapWarningModal.jsx
 */
import React from 'react';
import { FiAlertTriangle, FiX, FiCheck } from 'react-icons/fi';
import './OverlapWarningModal.css';

function OverlapWarningModal({
                                 isOpen,
                                 onClose,
                                 onConfirm,
                                 overlappingEvents = [],
                                 newEventDetails = {}
                             }) {
    if (!isOpen) return null;

    const formatTime = (timeString) => {
        if (!timeString) return '';
        return timeString.substring(0, 5);
    };

    const formatEventTitle = (event) => {
        if (event.customerEntity) {
            const clientName = `${event.customerEntity.lastName} ${event.customerEntity.firstName}`;
            const eventTypeText = event.eventType === 'MONTAJ' ? 'Montaj' :
                event.eventType === 'MASURATORI' ? 'Măsurătoare' :
                    event.eventType;
            return `${eventTypeText} - ${clientName}`;
        } else {
            return event.description || 'Eveniment personal';
        }
    };

    return (
        <div className="overlap-warning-overlay">
            <div className="overlap-warning-content">
                <div className="overlap-warning-header">
                    <div className="warning-icon-container">
                        <FiAlertTriangle className="warning-icon" />
                        <h2>Conflict de evenimente</h2>
                    </div>
                    <button className="overlap-close-button" onClick={onClose}>
                        <FiX />
                    </button>
                </div>

                <div className="overlap-warning-body">
                    <div className="new-event-section">
                        <h3>Eveniment nou:</h3>
                        <div className="event-details">
                            <span className="event-time">
                                {formatTime(newEventDetails.startTime)} - {formatTime(newEventDetails.endTime)}
                            </span>
                            <span className="event-title">
                                {newEventDetails.title || newEventDetails.description || 'Eveniment nou'}
                            </span>
                            <span className="event-date">
                                {newEventDetails.date}
                            </span>
                        </div>
                    </div>

                    <div className="conflicting-events-section">
                        <h3>
                            Se suprapune cu {overlappingEvents.length} eveniment{overlappingEvents.length === 1 ? '' : 'e'} existent{overlappingEvents.length === 1 ? '' : 'e'}:
                        </h3>
                        <div className="conflicting-events-list">
                            {overlappingEvents.map((event, index) => (
                                <div key={event.id || index} className="conflicting-event-item">
                                    <div className="conflict-indicator"></div>
                                    <div className="event-info">
                                        <span className="event-time">
                                            {formatTime(event.startTime)} - {formatTime(event.endTime)}
                                        </span>
                                        <span className="event-title">
                                            {formatEventTitle(event)}
                                        </span>
                                        {event.customerEntity && (
                                            <span className="event-meta">
                                                Telefon: {event.customerEntity.phone1 || 'N/A'}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="warning-message">
                        <p>
                            <strong>Doriți să continuați?</strong> Evenimentul va fi salvat chiar dacă se suprapune cu alte evenimente programate.
                        </p>
                    </div>
                </div>

                <div className="overlap-warning-footer">
                    <button
                        className="cancel-button"
                        onClick={onClose}
                    >
                        <FiX />
                        Anulează
                    </button>
                    <button
                        className="confirm-button"
                        onClick={onConfirm}
                    >
                        <FiCheck />
                        Salvează oricum
                    </button>
                </div>
            </div>
        </div>
    );
}

export default OverlapWarningModal;